const mutations = {
  'SET_REGIONSTORES' (state, value) {
    state.regionStores = value
  },
  'SET_REGIONSTORE' (state, value) {
    state.regionStore = value
  }
}
export default mutations
